(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vuejs-mobile-datepicker", [], factory);
	else if(typeof exports === 'object')
		exports["vuejs-mobile-datepicker"] = factory();
	else
		root["vuejs-mobile-datepicker"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MobileDatepicker",
  props: {
    showPickerModel: {
      //控制显隐
      type: Boolean,
      default: false
    },
    defaultDate: {
      //默认选中日期
      type: Date,
      default: function _default() {
        return new Date();
      }
    },
    startDate: {
      //可选范围开始日期
      type: Date,
      default: function _default() {
        return new Date("1900-1-1");
      }
    },
    endDate: {
      //可选范围结束日期
      type: Date,
      default: function _default() {
        return new Date();
      }
    },
    disableDate: {
      //禁用日期函数
      type: Function
    },
    markWeekend: {
      //标记周末
      type: Boolean,
      default: false
    },
    language: {
      //语言
      type: String,
      default: "zh"
    }
  },
  created: function created() {
    if (this.showPickerModel && this.defaultDate) {
      //保证刷新，数据不丢失
      this.initDate(this.defaultDate); //初始化日期
    }
  },
  data: function data() {
    return {
      weeks: ["日", "一", "二", "三", "四", "五", "六"], //周 数组
      enMonth: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], //英文 月份
      enShortWeeks: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], //英文 周
      days: [], //某年某月的日期数组，如[0,0,1,2,3,4,....,31]
      years: [], //可选范围的年份数组，如[1991,1992,...,2019]
      monthLastDay: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], //某年对应月份最大天数
      year: null,
      currentYear: null,
      month: null,
      currentMonth: null,
      day: null,
      currentDay: null,
      week: null,
      changeContentFlag: false //切换主体内容显示为日期或年份
    };
  },

  watch: {
    showPickerModel: function showPickerModel(newVal, oldVal) {
      //监测showPickerModel的变动
      if (newVal) {
        //showPickerModel由false变为true
        if (this.defaultDate >= this.startDate && this.defaultDate <= this.endDate) {
          //默认时间在起止时间之内
          this.initDate(this.defaultDate); //初始化
        } else {
          this.$emit("cancel"); //触发取消事件
        }
      }
    }
  },
  computed: {
    isEnglish: function isEnglish() {
      //语言版本是否为英语
      return this.language == "en";
    },
    currentDateText: function currentDateText() {
      //当前日期显示文本
      if (this.isEnglish) {
        if (this.enMonth[this.currentMonth]) {
          return this.enShortWeeks[this.weeks.indexOf(this.week)] + ", " + this.enMonth[this.currentMonth].substring(0, 3) + " " + this.currentDay;
        } else {
          return this.enShortWeeks[this.weeks.indexOf(this.week)] + ", ";
        }
      } else {
        return this.currentMonth + 1 + "月" + this.currentDay + "日周" + this.week;
      }
    },
    currentMonthText: function currentMonthText() {
      //当前月份显示文本
      if (this.isEnglish) {
        return this.enMonth[this.month] + " " + this.year;
      } else {
        return this.year + "年" + (this.month + 1) + "月";
      }
    }
  },
  methods: {
    handleCancel: function handleCancel() {
      //处理取消点击
      this.changeContentFlag = false; //关闭年份选择面板
      this.$emit("cancel"); //触发取消事件
    },
    handleConfirm: function handleConfirm() {
      //处理确认点击
      this.changeContentFlag = false; //关闭年份选择面板
      this.$emit("confirm", this.currentYear + "-" + (this.currentMonth + 1) + "-" + this.currentDay); //触发确认事件，参数为选择的日期，如2019-7-7
    },
    initDate: function initDate(defaultDate) {
      //初始化日期
      this.currentYear = this.year = defaultDate.getFullYear(); //年
      this.currentMonth = this.month = defaultDate.getMonth(); //月
      this.currentDay = this.day = defaultDate.getDate(); //日
      this.week = this.weeks[defaultDate.getDay()]; //周
      this.years = [];
      for (var i = 0; i <= this.endDate.getFullYear() - this.startDate.getFullYear(); i++) {
        this.years.push(Number(this.startDate.getFullYear()) + i); //初始化年份列表
      }
      this.updateDate(this.year, this.month); //根据年月更新日期
    },
    updateDate: function updateDate(year, month) {
      //根据年月更新日期
      this.monthLastDay[1] = 28; //平年
      if (year % 4 == 0 && year % 100 != 0 || year % 400 == 0) {
        //闰年
        this.monthLastDay[1] = 29; //2月有29天
      }
      var firstDay = new Date(year, month, 1).getDay(); //根据年月获取第一天是周几
      this.days = [];
      for (var i = 0; i < firstDay; i++) {
        this.days.push(0); //往第一天前面补0，如第一天周二，则需前面补2个0
      }
      for (var j = 1; j <= this.monthLastDay[month]; j++) {
        this.days.push(j); //补完0后，根据该月最大的天数，从累加，如1,2,3...
      }
    },
    preMonth: function preMonth() {
      //上一个月
      if (this.month == 0) {
        //如果当前月为第一个月，年份减一，月份置十二
        this.year = this.year - 1;
        this.month = 11;
      } else {
        this.month--;
      }
      this.updateDate(this.year, this.month); //根据年月更新日期
    },
    nextMonth: function nextMonth() {
      //下一个月
      if (this.month == 11) {
        //如果当前月为最后一个月，年份加一，月份置一
        this.year = this.year + 1;
        this.month = 0;
      } else {
        this.month++;
      }
      this.updateDate(this.year, this.month); //根据年月更新日期
    },
    handleClickDay: function handleClickDay(item) {
      //处理日期点击事件
      if (this.startDate > new Date(this.year, this.month, item) || this.endDate < new Date(this.year, this.month, item) || item == 0) {
        return; //不在指定范围的，属于禁用的日期不做点击处理
      }
      if (typeof this.disableDate == "function" && this.disableDate(this.year + "-" + (this.month + 1) + "-" + item)) {
        ////禁用函数存在，符合禁用规则
        return;
      }
      this.currentYear = this.year; //更新到当前点击日期
      this.currentMonth = this.month;
      this.currentDay = this.day = item;
      var date = new Date(this.currentYear, this.currentMonth, this.currentDay);
      this.week = this.weeks[date.getDay()]; //获取更新日期周
    },
    handleClickYear: function handleClickYear(item) {
      //处理年份点击事件
      if (new Date(item, this.month, this.day) < this.startDate) {
        //超出最小可选日期，置为最小日期
        this.year = this.currentYear = this.startDate.getFullYear();
        this.month = this.currentMonth = this.startDate.getMonth();
        this.day = this.currentDay = this.startDate.getDate();
        this.week = this.weeks[this.startDate.getDay()];
      } else if (new Date(item, this.month, this.day) > this.endDate) {
        //超出最大可选日期，置为最大日期
        this.year = this.currentYear = this.endDate.getFullYear();
        this.month = this.currentMonth = this.endDate.getMonth();
        this.day = this.currentDay = this.endDate.getDate();
        this.week = this.weeks[this.endDate.getDay()];
      } else {
        //更新到当前点击日期
        if (typeof this.disableDate == "function" && this.disableDate(item + "-" + (this.currentMonth + 1) + "-" + this.day)) {
          //禁用函数存在，符合禁用规则
          this.year = item; //更新切换面板年月
          this.updateDate(this.year, this.month); //根据年月更新日期
          this.changeContentFlag = false; //关闭年份选择面板
          return;
        }
        if (!(item % 4 == 0 && item % 100 != 0 || item % 400 == 0) && this.currentMonth == 1 && this.currentDay == 29) {
          //从闰年2月29日到平年
          this.year = item; //更新切换面板年月
          this.updateDate(this.year, this.month); //根据年月更新日期
          this.changeContentFlag = false; //关闭年份选择面板
          return;
        }
        this.year = this.currentYear = item;
        this.month = this.currentMonth;
        this.day = this.currentDay; //更新切换面板年月日
        var date = new Date(this.year, this.month, this.day);
        this.week = this.weeks[date.getDay()];
      }
      this.updateDate(this.year, this.month); //根据年月更新日期
      this.changeContentFlag = false; //关闭年份选择面板
    },
    showDatePicker: function showDatePicker() {
      //显示选择日期面板
      if (this.changeContentFlag) {
        this.changeContentFlag = false;
      }
    },
    showYearPicker: function showYearPicker() {
      var _this = this;

      //显示选择年份面板
      if (!this.changeContentFlag) {
        this.changeContentFlag = true;
        var scrollYearListY = void 0; //年份列表Y轴上滚动距离
        this.$nextTick(function () {
          //使用nextTick为了保证dom元素都已经渲染完毕
          scrollYearListY = (_this.currentYear - _this.startDate.getFullYear() - 3) * _this.$refs.mdp_year_list.firstElementChild.offsetHeight;
          scrollYearListY = scrollYearListY < 0 ? 0 : scrollYearListY;
          _this.$refs.mdp_year_list.scrollTop = scrollYearListY;
        });
      }
    },
    activeDay: function activeDay(day) {
      //选中日期
      return day == this.currentDay && this.month == this.currentMonth && !this.dayIsDisable(day);
    },
    dayIsDisable: function dayIsDisable(item) {
      //禁用日期，返回true为禁用
      if (item == 0) {
        return false;
      }
      if (this.startDate - new Date(this.year + "-" + (this.month + 1) + "-" + item) > 0 || new Date(this.year + "-" + (this.month + 1) + "-" + item) - this.endDate > 0) {
        //日期不在起止日期范围禁用
        return true;
      } else if (this.disableDate && typeof this.disableDate == "function") {
        //禁用函数存在，符合函数规则，禁用
        if (this.disableDate(this.year + "-" + (this.month + 1) + "-" + item)) return true;
      }
      return false;
    },
    dayIsWeekend: function dayIsWeekend(index) {
      //是否为周末
      if (index % 7 == 0 || index % 7 == 6) {
        return true;
      }
      return false;
    }
  }
});

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MobileDatePicker_vue__ = __webpack_require__(2);

__WEBPACK_IMPORTED_MODULE_0__MobileDatePicker_vue__["a" /* default */].install = function (Vue) {
    Vue.component('MobileDatePicker', __WEBPACK_IMPORTED_MODULE_0__MobileDatePicker_vue__["a" /* default */]);
};
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(__WEBPACK_IMPORTED_MODULE_0__MobileDatePicker_vue__["a" /* default */]);
}
/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__MobileDatePicker_vue__["a" /* default */]);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileDatePicker_vue__ = __webpack_require__(0);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_373e8481_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileDatePicker_vue__ = __webpack_require__(9);
function injectStyle (ssrContext) {
  __webpack_require__(3)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileDatePicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_373e8481_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileDatePicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("48c1e764", content, true, {});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "@media (min-width:240px){html{font-size:32px}}@media (min-width:320px){html{font-size:42.66667px}}@media (min-width:360px){html{font-size:48px}}@media (min-width:375px){html{font-size:50px}}@media (min-width:384px){html{font-size:51.2px}}@media (min-width:411px){html{font-size:54.8px}}@media (min-width:414px){html{font-size:55.2px}}@media (min-width:424px){html{font-size:56.53333px}}@media (min-width:480px){html{font-size:64px}}@media (min-width:540px){html{font-size:72px}}@media (min-width:640px){html{font-size:85.33333px}}@media (min-width:720px){html{font-size:96px}}@media (min-width:750px){html{font-size:100px}}@media (min-width:768px){html{font-size:102.4px}}@media (min-width:800px){html{font-size:106.66667px}}@media (min-width:980px){html{font-size:130.66667px}}@media (min-width:1024px){html{font-size:136.53333px}}@media (min-width:1080px){html{font-size:144px}}@media (min-width:1152px){html{font-size:153.6px}}@media (min-width:1366px){html{font-size:182.13333px}}@media (min-width:1440px){html{font-size:192px}}@media (min-width:2160px){html{font-size:288px}}html{font-family:font-apple-system,system-ui,BlinkMacSystemFont,Helvetica Neue,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Arial,sans-serif}*{margin:0;padding:0}ol,ul{list-style:none}#mobile-datepicker{position:fixed;top:0;left:0;bottom:0;width:100%;height:100%;background-color:rgba(0,0,0,.5);display:flex;justify-content:center;align-items:center}.mdp_container{width:80%;height:10rem;background-color:#fff}.mdp_header{height:2rem;background-color:#dd2727;box-sizing:border-box;color:#eee;padding:.4rem .6rem;font-size:0}.mdp_current_year{font-size:.3125rem;display:inline-block}.mdp_current_date{font-size:.6125rem;display:inline-block}.mdp_current_date.active,.mdp_current_year.active{color:#fff}.mdp_content{width:100%;height:6.8rem;background:#fff}.mdp_date_content{width:100%;height:100%;box-sizing:border-box;padding:0 .6rem .4rem}.mdp_switch_month{display:flex;justify-content:space-between;align-items:center;height:1.2rem;font-weight:500;font-size:.3125rem}.mdp_arrow_action{display:flex;justify-content:center;align-items:center;min-height:.6rem;min-width:.6rem}.mdp_arrow{display:inline-block;width:.16rem;height:.16rem;border-top:.04rem solid #000;border-left:.04rem solid #000}.mdp_left{transform:rotate(-45deg)}.mdp_right{transform:rotate(135deg)}.mdp_arrow_hide{visibility:hidden}.mdp_weeks{width:100%;font-size:.25rem;color:#888}.mdp_week,.mdp_weeks{display:flex;align-items:center}.mdp_week{width:14.2%;height:.8rem;justify-content:center}.mdp_week.mark{color:#dd2727}.mdp_pick_day{font-size:.25rem;width:100%;flex-wrap:wrap}.mdp_day,.mdp_pick_day{display:flex;align-items:center}.mdp_day{width:14.2%;height:.8rem;justify-content:center}.mdp_day.mdp_day_disable{background-color:#f5f7fa;cursor:not-allowed;color:#c0c4cc!important}.mdp_day.mark{color:#dd2727}.mdp_day.active{width:14.2%;background-color:#dd2727;border-radius:50%;color:#fff}.mdp_year_content{width:100%;height:100%;display:flex;justify-content:center;align-items:center;border-bottom:.02rem solid #eee}.mdp_year_content ul{width:100%;height:100%;overflow:scroll;font-size:.3125rem}.mdp_year_content ul li{padding:.4rem 0;height:1rem;box-sizing:border-box;display:flex;justify-content:center;align-items:center}.mdp_year_content ul li.active{font-size:.465rem;color:#dd2727}.mdp_operate_button{margin:0 .6rem;height:1.2rem;display:flex;justify-content:flex-end;align-items:center}.mdp_button{border:none;outline:none;color:#dd2727;background-color:#fff;font-weight:500;font-size:.275rem}.mdp_cancel_button{margin-right:.6rem}", ""]);

// exports


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(7)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 7 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPickerModel),expression:"showPickerModel"}],attrs:{"id":"mobile-datepicker"},on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.handleCancel($event)}}},[_c('div',{staticClass:"mdp_container"},[_c('div',{staticClass:"mdp_header"},[_c('div',{staticClass:"mdp_current_year",class:{'active':_vm.changeContentFlag},on:{"click":function($event){return _vm.showYearPicker()}}},[_vm._v(_vm._s(_vm.currentYear)+_vm._s(_vm.isEnglish?"":"年"))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"mdp_current_date",class:{'active':!_vm.changeContentFlag},on:{"click":function($event){return _vm.showDatePicker()}}},[_vm._v(_vm._s(_vm.currentDateText))])]),_vm._v(" "),_c('div',{staticClass:"mdp_content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.changeContentFlag),expression:"!changeContentFlag"}],staticClass:"mdp_date_content"},[_c('div',{staticClass:"mdp_switch_month"},[_c('span',{staticClass:"mdp_arrow_action",class:{'mdp_arrow_hide':_vm.startDate-new Date(_vm.year,_vm.month,1)>=0},on:{"click":_vm.preMonth}},[_c('span',{staticClass:"mdp_left mdp_arrow"})]),_vm._v(" "),_c('span',{staticClass:"mdp_current_month"},[_vm._v(_vm._s(_vm.currentMonthText))]),_vm._v(" "),_c('span',{staticClass:"mdp_arrow_action",class:{'mdp_arrow_hide':_vm.endDate-new Date(_vm.year,_vm.month+1,1)<=0},on:{"click":_vm.nextMonth}},[_c('span',{staticClass:"mdp_right mdp_arrow"})])]),_vm._v(" "),_c('div',{staticClass:"mdp_weeks"},_vm._l((_vm.isEnglish?_vm.enShortWeeks:_vm.weeks),function(item,index){return _c('span',{key:index,staticClass:"mdp_week",class:{'mark':_vm.markWeekend&&(index==0||index==6)}},[_vm._v(_vm._s(_vm.isEnglish?item[0]:item))])}),0),_vm._v(" "),_c('div',{staticClass:"mdp_pick_day"},_vm._l((_vm.days),function(item,index){return _c('span',{key:index,staticClass:"mdp_day",class:{'active':_vm.activeDay(item),'mdp_day_disable':_vm.dayIsDisable(item),'mark': _vm.markWeekend&&_vm.dayIsWeekend(index)},on:{"click":function($event){return _vm.handleClickDay(item)}}},[_vm._v(_vm._s(item?item:' '))])}),0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.changeContentFlag),expression:"changeContentFlag"}],staticClass:"mdp_year_content"},[_c('ul',{ref:"mdp_year_list"},_vm._l((_vm.years),function(item,index){return _c('li',{key:index,class:{'active':item==_vm.currentYear},on:{"click":function($event){return _vm.handleClickYear(item)}}},[_vm._v(_vm._s(item))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"mdp_operate_button"},[_c('button',{staticClass:"mdp_cancel_button mdp_button",on:{"click":_vm.handleCancel}},[_vm._v(_vm._s(_vm.isEnglish?"CANCEL":"取消"))]),_vm._v(" "),_c('button',{staticClass:"mdp_sure_button mdp_button",on:{"click":_vm.handleConfirm}},[_vm._v(_vm._s(_vm.isEnglish?"OK":"确认"))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// vuejs-mobile-datepicker.js